import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15 0H1a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1zm-1.708 3.791l-.858.823a.251.251 0 00-.1.241V10.9a.251.251 0 00.1.241l.838.823v.181H9.057v-.181l.868-.843c.085-.085.085-.11.085-.241V5.993L7.6 12.124h-.329l-2.81-6.13V10.1a.567.567 0 00.156.472l1.129 1.37v.181h-3.2v-.181l1.129-1.37a.547.547 0 00.146-.472V5.351A.416.416 0 003.683 5l-1-1.209V3.61H5.8l2.4 5.283 2.122-5.283h2.971l-.001.181z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }